import { GraphQLClient } from 'graphql-request';
import { print } from 'graphql';
import gql from 'graphql-tag';
export type Maybe<T> = T | undefined;
export type Exact<T extends { [key: string]: any }> = { [K in keyof T]: T[K] };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
};



export type Query = {
  workspace?: Maybe<WorkspaceWithTests>;
  workspacesByOrgId: Array<OrgWorkspace>;
  audienceTestCounts: Array<AccountAudienceTestCount>;
  account?: Maybe<AccountWithDescendants>;
  userPermission: GroupsPermission;
  alpha: Scalars['Boolean'];
  templatesByAccount: Array<Template>;
  template: Template;
  mgtTest?: Maybe<MgtTest>;
  sharedPrototypes: Array<Prototype>;
  audience: Audience;
  organizationUsers: Array<User>;
  workspaceUsers: Array<User>;
  sharedReports: Array<SharedReports>;
  featureFlags: Array<FeatureFlag>;
  userPayload?: Maybe<UserPayload>;
  survey?: Maybe<Survey>;
  me?: Maybe<Session>;
  organizationPriority: OrganizationPriority;
  testConfig?: Maybe<TestConfig>;
  checkResetPasswordToken: CheckTokenResponse;
  searchResponses?: Maybe<SearchResults>;
};


export type QueryWorkspaceArgs = {
  id: Scalars['String'];
};


export type QueryWorkspacesByOrgIdArgs = {
  orgId: Scalars['String'];
};


export type QueryAudienceTestCountsArgs = {
  accountId: Scalars['String'];
  audienceIds: Array<Scalars['String']>;
};


export type QueryAccountArgs = {
  id: Scalars['String'];
};


export type QueryUserPermissionArgs = {
  groupId: Scalars['String'];
};


export type QueryTemplatesByAccountArgs = {
  accountId: Scalars['String'];
};


export type QueryTemplateArgs = {
  id: Scalars['String'];
  accountId: Scalars['String'];
};


export type QueryMgtTestArgs = {
  workspaceId: Scalars['String'];
  testId: Scalars['String'];
};


export type QuerySharedPrototypesArgs = {
  workspaceId: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryAudienceArgs = {
  id: Scalars['String'];
  accountId: Scalars['String'];
};


export type QueryOrganizationUsersArgs = {
  orgId: Scalars['String'];
};


export type QueryWorkspaceUsersArgs = {
  workspaceId: Scalars['String'];
};


export type QuerySharedReportsArgs = {
  workspaceId: Scalars['String'];
  reportIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryFeatureFlagsArgs = {
  workspaceId?: Maybe<Scalars['String']>;
  accountId?: Maybe<Scalars['String']>;
  orgId?: Maybe<Scalars['String']>;
};


export type QuerySurveyArgs = {
  workspaceId: Scalars['String'];
  testId: Scalars['String'];
  sharedLinkHash?: Maybe<Scalars['String']>;
};


export type QueryOrganizationPriorityArgs = {
  orgId: Scalars['String'];
  workspaceId?: Maybe<Scalars['String']>;
};


export type QueryTestConfigArgs = {
  workspaceId?: Maybe<Scalars['String']>;
  testId?: Maybe<Scalars['String']>;
  sharedLinkHash?: Maybe<Scalars['String']>;
};


export type QueryCheckResetPasswordTokenArgs = {
  token: Scalars['String'];
};


export type QuerySearchResponsesArgs = {
  searchTerm: Scalars['String'];
  workspaceId: Scalars['String'];
  questionId: Scalars['String'];
  sharedLinkHash?: Maybe<Scalars['String']>;
};

export type Mutation = {
  createWorkspace: Workspace;
  updateProject: Project;
  createProject: Project;
  createComment: UserComment;
  updateAudience?: Maybe<Audience>;
  manageResponses: ManageResponsesResult;
  createTest: Test;
  updateTest: Test;
  createCsv: CsvResponse;
  createScreenerCsv: CsvResponse;
  createTestConfig: TestConfigCreateResponse;
  toggleSharedLink: ToggleShareLinkResponse;
  changePassword: GenericResponse;
  forgotPasswordEmail: GenericResponse;
  resetPassword?: Maybe<GenericResponse>;
  indexResponses: Scalars['Boolean'];
  updateBranding?: Maybe<Branding>;
};


export type MutationCreateWorkspaceArgs = {
  name: Scalars['String'];
  iconUrl: Scalars['String'];
};


export type MutationUpdateProjectArgs = {
  workspaceId: Scalars['String'];
  projectId: Scalars['String'];
  payload: UpdateProjectInput;
};


export type MutationCreateProjectArgs = {
  workspaceId: Scalars['String'];
  payload: CreateProjectInput;
};


export type MutationCreateCommentArgs = {
  workspaceId: Scalars['String'];
  testId: Scalars['String'];
  payload: UserCommentInput;
};


export type MutationUpdateAudienceArgs = {
  accountId: Scalars['String'];
  audienceId: Scalars['String'];
  payload: AudienceInput;
};


export type MutationManageResponsesArgs = {
  workspaceId: Scalars['String'];
  surveyId: Scalars['String'];
  payload: ManageResponsesInput;
  pValue?: Maybe<Scalars['Int']>;
  blackListedRIDs?: Maybe<Array<Scalars['String']>>;
  minSampleCategory?: Maybe<Scalars['Int']>;
  CIpercentage?: Maybe<Scalars['Int']>;
};


export type MutationCreateTestArgs = {
  workspaceId: Scalars['String'];
  payload: CreateTestInput;
};


export type MutationUpdateTestArgs = {
  workspaceId: Scalars['String'];
  testId: Scalars['String'];
  payload: UpdateTestInput;
};


export type MutationCreateCsvArgs = {
  workspaceId: Scalars['String'];
  surveyId: Scalars['String'];
};


export type MutationCreateScreenerCsvArgs = {
  workspaceId: Scalars['String'];
  testId: Scalars['String'];
};


export type MutationCreateTestConfigArgs = {
  payload: TestConfigInput;
};


export type MutationToggleSharedLinkArgs = {
  workspaceId: Scalars['String'];
  testId: Scalars['String'];
  createLink: Scalars['Boolean'];
};


export type MutationChangePasswordArgs = {
  userId: Scalars['String'];
  payload: NewPasswordPayload;
};


export type MutationForgotPasswordEmailArgs = {
  email: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  userId: Scalars['String'];
  token: Scalars['String'];
  password: Scalars['String'];
};


export type MutationIndexResponsesArgs = {
  questionId: Scalars['String'];
};


export type MutationUpdateBrandingArgs = {
  workspaceId: Scalars['String'];
  payload: BrandingInput;
};

export enum TestStatus {
  Draft = 'DRAFT',
  InReview = 'IN_REVIEW',
  InProgress = 'IN_PROGRESS',
  Complete = 'COMPLETE'
}

export type Session = {
  uid: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  defaultWorkspaceId: Scalars['ID'];
  workspaces: Array<Workspace>;
  featureConfig: Scalars['JSON'];
  workspaceAccessLevels: Array<WorkspaceAccessLevel>;
  orgAdminAccess?: Maybe<Array<Maybe<Scalars['String']>>>;
  admin?: Maybe<Scalars['Boolean']>;
};

export type Account = {
  id: Scalars['String'];
  createdAt: Scalars['DateTime'];
  name: Scalars['String'];
  iconUrl: Scalars['String'];
  authDomains: Array<Scalars['String']>;
};

export type AccountWithDescendants = {
  id: Scalars['String'];
  createdAt: Scalars['DateTime'];
  name: Scalars['String'];
  iconUrl: Scalars['String'];
  authDomains: Array<Scalars['String']>;
  organizations: Array<OrganizationWithWorkspaces>;
};

export type Organization = {
  id: Scalars['String'];
  createdAt: Scalars['DateTime'];
  name: Scalars['String'];
  iconUrl: Scalars['String'];
  description?: Maybe<Scalars['String']>;
};

export type OrganizationWithWorkspaces = {
  id: Scalars['String'];
  createdAt: Scalars['DateTime'];
  name: Scalars['String'];
  iconUrl: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  workspaces: Array<Workspace>;
};

export type Permissions = {
  id: Scalars['ID'];
  group_id: Scalars['String'];
  group_type: Scalars['String'];
  actions: Array<Scalars['String']>;
  resource?: Maybe<Scalars['String']>;
  disabled_by?: Maybe<Scalars['String']>;
  disabled_at?: Maybe<Scalars['String']>;
};

export type Template = {
  id: Scalars['Int'];
  created_by?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  featured?: Maybe<Scalars['String']>;
  template_fields?: Maybe<Scalars['JSON']>;
  questions?: Maybe<Scalars['JSON']>;
  parent_id?: Maybe<Scalars['Float']>;
  created_at?: Maybe<Scalars['String']>;
  hidden?: Maybe<Scalars['Boolean']>;
};

export type SharedReports = {
  id: Scalars['Int'];
  reference?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  source_id?: Maybe<Scalars['String']>;
  source_type?: Maybe<Scalars['String']>;
  creator_email?: Maybe<Scalars['String']>;
  creator_name?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
  report?: Maybe<Scalars['JSON']>;
  active?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
};

export type UserPayload = {
  company: Scalars['String'];
  primary_account: Scalars['String'];
  accounts: Array<Scalars['String']>;
  firstname: Scalars['String'];
  lastname?: Maybe<Scalars['String']>;
  show_tutorial?: Maybe<Scalars['Boolean']>;
  permissions?: Maybe<Scalars['JSON']>;
  preferences?: Maybe<Scalars['JSON']>;
  tester?: Maybe<Scalars['String']>;
};

export type User = {
  payload: UserPayload;
  type?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  fullName: Scalars['String'];
  userName: Scalars['String'];
  abbreviation: Scalars['String'];
  email: Scalars['String'];
  admin: Scalars['Boolean'];
};

export type CreateTestInput = {
  segment?: Maybe<AudienceReferenceInput>;
  title?: Maybe<Scalars['String']>;
  objective?: Maybe<Scalars['String']>;
  decisionContext?: Maybe<Scalars['String']>;
  customerQuestions?: Maybe<Scalars['String']>;
  status: TestStatus;
  prototypes?: Maybe<Scalars['JSON']>;
  testType?: Maybe<Scalars['String']>;
  lastSubmittedAt?: Maybe<Scalars['DateTime']>;
  activeviewid?: Maybe<Scalars['String']>;
  relatedIds?: Maybe<Array<Scalars['String']>>;
  followUp?: Maybe<Scalars['Int']>;
  renderedTemplate?: Maybe<Array<Scalars['JSON']>>;
  testTemplateId?: Maybe<Scalars['Int']>;
  templateFieldValues?: Maybe<Scalars['JSON']>;
  additional_info?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  comparison_type?: Maybe<Scalars['String']>;
};

export type UpdateTestInput = {
  segment?: Maybe<AudienceReferenceInput>;
  title?: Maybe<Scalars['String']>;
  objective?: Maybe<Scalars['String']>;
  decisionContext?: Maybe<Scalars['String']>;
  customerQuestions?: Maybe<Scalars['String']>;
  status?: Maybe<TestStatus>;
  prototypes?: Maybe<Scalars['JSON']>;
  assets?: Maybe<Scalars['JSON']>;
  formtype?: Maybe<Scalars['String']>;
  testType?: Maybe<Scalars['String']>;
  testTemplateLaunched?: Maybe<Scalars['Boolean']>;
  lastSubmittedAt?: Maybe<Scalars['DateTime']>;
  tags?: Maybe<Scalars['String']>;
  answer?: Maybe<Scalars['String']>;
  activeviewid?: Maybe<Scalars['String']>;
  renderedTemplate?: Maybe<Array<Scalars['JSON']>>;
  testTemplateId?: Maybe<Scalars['Int']>;
  templateFieldValues?: Maybe<Scalars['JSON']>;
  auto_survey?: Maybe<Scalars['Boolean']>;
  additional_info?: Maybe<Scalars['String']>;
  comparison_type?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type AudienceReferenceInput = {
  title: Scalars['String'];
  id: Scalars['String'];
};

export type AudienceReference = {
  title: Scalars['String'];
  id: Scalars['String'];
};

export type Test = {
  id: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  createdBy: UserReference;
  title?: Maybe<Scalars['String']>;
  status: TestStatus;
  prototypes: Array<Prototype>;
  tags: Array<Scalars['String']>;
  objective?: Maybe<Scalars['String']>;
  decisionContext?: Maybe<Scalars['String']>;
  customerQuestions?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  additionalInfo?: Maybe<Scalars['String']>;
  audience?: Maybe<AudienceReference>;
  testTemplateId?: Maybe<Scalars['Int']>;
};

export type UserReference = {
  id: Scalars['String'];
  uri?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type GroupsPermission = {
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions: PermissionsObject;
};

export type FeatureFlag = {
  title: Scalars['String'];
  key: Scalars['String'];
  description: Scalars['String'];
  level: Array<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  defaultEnabled: Scalars['Boolean'];
  overridden: Scalars['Boolean'];
  enabled: Scalars['Boolean'];
  config: Scalars['JSON'];
  defaultConfig?: Maybe<Scalars['JSON']>;
};

export type PermissionsObject = {
  templateQuestionModification?: Maybe<Array<Scalars['String']>>;
};

export type Workspace = {
  id: Scalars['String'];
  createdAt: Scalars['DateTime'];
  name: Scalars['String'];
  iconUrl: Scalars['String'];
  projectCount: Scalars['Int'];
  testCount: Scalars['Int'];
  accountManager?: Maybe<Scalars['String']>;
  organizationId: Scalars['String'];
};

export type WorkspaceAccessLevel = {
  id: Scalars['String'];
  accessLevel: Scalars['String'];
};

export type OrgWorkspace = {
  _id: Scalars['String'];
  name: Scalars['String'];
  payload: Scalars['JSON'];
  createdAt: Scalars['DateTime'];
};

export type WorkspaceWithTests = {
  id: Scalars['String'];
  createdAt: Scalars['DateTime'];
  name: Scalars['String'];
  iconUrl: Scalars['String'];
  tests: Array<Test>;
  accountId: Scalars['ID'];
  organizationId: Scalars['ID'];
  projects: Array<Project>;
  audiences: Array<Audience>;
  accountAudiences: Array<Audience>;
  branding?: Maybe<Branding>;
  mgtWorkspace: MgtWorkspace;
};

export type Branding = {
  id: Scalars['String'];
  workspaceId: Scalars['String'];
  monochromatic: Scalars['String'];
  sequentialPalette: Scalars['String'];
  divergentPalette: Array<Scalars['String']>;
  qualitativePalette: Array<Scalars['String']>;
  createdAt: Scalars['DateTime'];
};

export type MgtWorkspace = {
  id: Scalars['String'];
  name: Scalars['String'];
  createdAt: Scalars['Int'];
  updatedAt: Scalars['Int'];
  count: Scalars['Int'];
  drops: Array<Maybe<Scalars['JSON']>>;
  payload: Scalars['JSON'];
};

export type Project = {
  id: Scalars['String'];
  title: Scalars['String'];
  prototypes: Array<Prototype>;
  desc: Scalars['String'];
  audiences: Array<Scalars['String']>;
  ids: Array<Scalars['String']>;
};

export type UpdateProjectInput = {
  title?: Maybe<Scalars['String']>;
  desc?: Maybe<Scalars['String']>;
  assets?: Maybe<Scalars['JSON']>;
  audiences?: Maybe<Array<Scalars['String']>>;
  ids?: Maybe<Array<Scalars['String']>>;
  hidden?: Maybe<Scalars['Boolean']>;
  delete?: Maybe<DeleteProjectPropertyInput>;
};

export type DeleteProjectPropertyInput = {
  ids?: Maybe<Array<Scalars['String']>>;
  audiences?: Maybe<Array<Scalars['String']>>;
  assets?: Maybe<Array<Scalars['String']>>;
};

export type CreateProjectInput = {
  title: Scalars['String'];
  desc: Scalars['String'];
};

export type UserComment = {
  id: Scalars['String'];
  firstName: Scalars['String'];
  comment: Scalars['String'];
  userId: Scalars['String'];
};

export type UserCommentInput = {
  comment: Scalars['String'];
  taggedUsers: Array<Scalars['String']>;
};

export type BrandingInput = {
  monochromatic: Scalars['String'];
  sequentialPalette: Scalars['String'];
  divergentPalette: Array<Scalars['String']>;
  qualitativePalette: Array<Scalars['String']>;
};

export type Prototype = {
  id: Scalars['String'];
  title: Scalars['String'];
  assetType?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  img?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
};

export type Audience = {
  _id: Scalars['String'];
  payload: Scalars['JSON'];
  name: Scalars['String'];
  drops: Array<Scalars['JSON']>;
};

export type AccountAudienceTestCount = {
  id?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
};

export type AudienceInput = {
  payload: Scalars['JSON'];
  name: Scalars['String'];
};

export type MgtTest = {
  followers: Array<User>;
  allUsers: Array<User>;
  comments: Array<UserComment>;
  data: Scalars['JSON'];
};

export type Survey = {
  id: Scalars['String'];
  respondents?: Maybe<Array<Respondent>>;
  questions?: Maybe<Array<Question>>;
  insights?: Maybe<InsightResponseObject>;
  workspaceId: Scalars['String'];
  testId: Scalars['String'];
  createdAt: Scalars['DateTime'];
};

export type Respondent = {
  id: Scalars['String'];
  simpleId: Scalars['String'];
  sessionId: Scalars['String'];
  age: Scalars['Int'];
  status: Scalars['String'];
  standardEmployment?: Maybe<Scalars['String']>;
  standardNumberOfEmployees?: Maybe<Scalars['String']>;
  standardHHIUS?: Maybe<Scalars['String']>;
  standardIndustryPersonal?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  standardEducation?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  msIsMobile?: Maybe<Scalars['Boolean']>;
  responses?: Maybe<Array<Response>>;
  race?: Maybe<Scalars['String']>;
  hispanicOrigin?: Maybe<Scalars['String']>;
  raceAndHispanicOrigin?: Maybe<Scalars['String']>;
};

export type Response = {
  id: Scalars['String'];
  questionId: Scalars['String'];
  respondentSurveyId?: Maybe<Scalars['String']>;
  otherAnswer?: Maybe<Scalars['String']>;
  explainAnswer?: Maybe<Scalars['String']>;
  textAnswer?: Maybe<Scalars['String']>;
  textArrayAnswer?: Maybe<Array<Maybe<Scalars['String']>>>;
  textMapAnswer?: Maybe<Scalars['JSON']>;
  status?: Maybe<Scalars['String']>;
  dataQualityCategories?: Maybe<Array<Maybe<DataQualityCategory>>>;
  sentimentLabel?: Maybe<SentimentLabel>;
  spacyPos?: Maybe<Array<Scalars['String']>>;
  spacyLemma?: Maybe<Array<Scalars['String']>>;
};

export enum DataQualityCategory {
  Allowed = 'ALLOWED',
  PersonalInfo = 'PERSONAL_INFO',
  RestrictedContent = 'RESTRICTED_CONTENT',
  Uninformative = 'UNINFORMATIVE',
  Inconsistent = 'INCONSISTENT',
  Disqualified = 'DISQUALIFIED',
  Gibberish = 'GIBBERISH',
  IncompleteSession = 'INCOMPLETE_SESSION',
  DefaultAcceptedLength = 'DEFAULT_ACCEPTED_LENGTH',
  Unknown = 'UNKNOWN'
}

export enum SentimentLabel {
  Negative = 'NEGATIVE',
  Positive = 'POSITIVE',
  Neutral = 'NEUTRAL'
}

export type Question = {
  id: Scalars['String'];
  type: Scalars['String'];
  order: Scalars['Int'];
  text: Scalars['String'];
  hasExplainOpt: Scalars['Boolean'];
  hasOtherOpt: Scalars['Boolean'];
  hasNaOpt: Scalars['Boolean'];
  parentQuestionIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  qualifyingTags: Array<Maybe<Scalars['String']>>;
  scaleProperties?: Maybe<ScaleProperties>;
  scaleGroupings?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  survey?: Maybe<Survey>;
  options?: Maybe<Array<QuestionOption>>;
  assets?: Maybe<Array<QuestionAsset>>;
  responses?: Maybe<Array<Response>>;
  configuration?: Maybe<QuestionConfig>;
};

export type QuestionOption = {
  id: Scalars['Int'];
  hash?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  order: Scalars['Int'];
  qualificationTags?: Maybe<Array<Maybe<Scalars['String']>>>;
  shuffle: Scalars['Boolean'];
  isTerminating: Scalars['Boolean'];
  isCorrectOption: Scalars['Boolean'];
  image?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  configuration?: Maybe<OptionConfig>;
};

export type QuestionAsset = {
  id: Scalars['Int'];
  type: Scalars['String'];
  url: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  forceOpen: Scalars['Boolean'];
  questionId?: Maybe<Scalars['String']>;
};

export type InsightItem = {
  type: Scalars['String'];
  questionId: Scalars['String'];
  demographic?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  option: Scalars['String'];
  alpha?: Maybe<Scalars['String']>;
  magnitude?: Maybe<Scalars['String']>;
  relMagnitudes?: Maybe<Scalars['String']>;
};

export type InsightResponseObject = {
  ahash: Scalars['String'];
  workspaceId: Scalars['String'];
  testId?: Maybe<Scalars['String']>;
  surveyId: Scalars['String'];
  insights: Array<InsightItem>;
  networkTime?: Maybe<Scalars['String']>;
  processingTime?: Maybe<Scalars['String']>;
  pValue: Scalars['Float'];
  minSampleCategory: Scalars['Int'];
  CIpercentage: Scalars['Int'];
  isCached?: Maybe<Scalars['Boolean']>;
};

export type QuestionConfig = {
  id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  questionId: Scalars['String'];
  surveyId?: Maybe<Scalars['String']>;
  visible: Scalars['Boolean'];
  context?: Maybe<Scalars['String']>;
};

export type OptionConfig = {
  id: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  questionOptionId: Scalars['Int'];
};

export type TestConfig = {
  id?: Maybe<Scalars['String']>;
  workspaceId: Scalars['String'];
  testId: Scalars['String'];
  findings?: Maybe<Array<Scalars['String']>>;
  sharedLinkHash?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  questionConfigs: Array<QuestionConfig>;
  optionConfigs: Array<OptionConfig>;
  testMetaDetails?: Maybe<TestMetaDetails>;
};

export type TestMetaDetails = {
  type: Scalars['String'];
  title: Scalars['String'];
  completedAt: Scalars['DateTime'];
  audienceId: Scalars['String'];
  workspaceId: Scalars['String'];
  audience?: Maybe<Audience>;
  workspaceIcon?: Maybe<Scalars['String']>;
  branding?: Maybe<Branding>;
};

export type TestConfigCreateResponse = {
  success: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
  configuration?: Maybe<TestConfig>;
};

export type ToggleShareLinkResponse = {
  success: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
  shareLinkHash?: Maybe<Scalars['String']>;
};

export type QuestionConfigInput = {
  title?: Maybe<Scalars['String']>;
  questionId: Scalars['String'];
  visible?: Maybe<Scalars['Boolean']>;
  context?: Maybe<Scalars['String']>;
};

export type OptionConfigInput = {
  title?: Maybe<Scalars['String']>;
  questionOptionId: Scalars['Int'];
};

export type TestConfigInput = {
  workspaceId: Scalars['String'];
  testId: Scalars['String'];
  surveyId: Scalars['String'];
  findings?: Maybe<Array<Scalars['String']>>;
  questionConfigs?: Maybe<Array<QuestionConfigInput>>;
  optionConfigs?: Maybe<Array<OptionConfigInput>>;
};

export type ScaleProperties = {
  maxLabel?: Maybe<Scalars['String']>;
  minLabel?: Maybe<Scalars['String']>;
  maxRating?: Maybe<Scalars['Int']>;
  minRating?: Maybe<Scalars['Int']>;
};

export type ManageResponsesInput = {
  respondents?: Maybe<Array<ManagementEventInput>>;
  responses?: Maybe<Array<ManagementEventInput>>;
};

export type ManagementEventInput = {
  id: Scalars['String'];
  status: RemovalStatus;
};

export type ManageResponsesResult = {
  success: Scalars['Boolean'];
  insights?: Maybe<InsightResponseObject>;
};

export enum RemovalStatus {
  Added = 'ADDED',
  Removed = 'REMOVED'
}

export type OrganizationPriority = {
  activeTests: Array<ActiveTest>;
  priority: PriorityList;
  datedOrgTests: Array<DatedTest>;
};

export type ActiveTest = {
  id: Scalars['Int'];
  payload: PriorityTestPayload;
  createdAt: Scalars['Int'];
  updatedAt: Scalars['Int'];
  createdBy: UserReference;
  workspaceId: Scalars['String'];
};

export type PriorityListItem = {
  testId: Scalars['Int'];
  workspaceId: Scalars['String'];
  prioritizedAt?: Maybe<Scalars['Int']>;
};

export type PriorityList = {
  capacity: Scalars['Int'];
  list: Array<PriorityListItem>;
  uuid: Scalars['String'];
};

export type PriorityTestPayload = {
  status: TestStatus;
  title: Scalars['String'];
  testType: Scalars['String'];
  prioritizedAt?: Maybe<Scalars['Int']>;
  lastSubmittedAt?: Maybe<Scalars['Int']>;
};

export type DatedTest = {
  workspaceId: Scalars['String'];
  id: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type CsvResponse = {
  status: Scalars['Boolean'];
  file?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
};

export type NewPasswordPayload = {
  oldPassword: Scalars['String'];
  newPassword: Scalars['String'];
};

export type GenericResponse = {
  status: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
};

export type CheckTokenResponse = {
  status: Scalars['Boolean'];
  userId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
};

export type SearchResults = {
  total: SearchTotals;
  max_score: Scalars['Float'];
  hits: Array<SearchHit>;
};

export type SearchTotals = {
  value: Scalars['Int'];
  relation: Scalars['String'];
};

export type SearchHit = {
  _index: Scalars['String'];
  _type: Scalars['String'];
  _id: Scalars['String'];
  _score: Scalars['Float'];
  highlight?: Maybe<Highlight>;
};

export type Highlight = {
  text: Array<Scalars['String']>;
};

export type AccountQueryVariables = Exact<{
  accountId: Scalars['String'];
}>;


export type AccountQuery = { account?: Maybe<{ organizations: Array<Pick<OrganizationWithWorkspaces, 'id' | 'name'>> }> };

export type AudienceQueryVariables = Exact<{
  id: Scalars['String'];
  accountId: Scalars['String'];
}>;


export type AudienceQuery = { audience: Pick<Audience, 'name' | '_id' | 'payload' | 'drops'> };

export type AudienceTestCountsQueryVariables = Exact<{
  accountId: Scalars['String'];
  audienceIds: Array<Scalars['String']>;
}>;


export type AudienceTestCountsQuery = { audienceTestCounts: Array<Pick<AccountAudienceTestCount, 'id' | 'count'>> };

export type ChangePasswordMutationVariables = Exact<{
  userId: Scalars['String'];
  payload: NewPasswordPayload;
}>;


export type ChangePasswordMutation = { changePassword: Pick<GenericResponse, 'status' | 'error'> };

export type CheckResetPasswordTokenQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type CheckResetPasswordTokenQuery = { checkResetPasswordToken: Pick<CheckTokenResponse, 'status' | 'userId' | 'error'> };

export type CreateCommentMutationVariables = Exact<{
  workspaceId: Scalars['String'];
  testId: Scalars['String'];
  payload: UserCommentInput;
}>;


export type CreateCommentMutation = { createComment: Pick<UserComment, 'firstName' | 'comment' | 'id'> };

export type CreateCsvMutationVariables = Exact<{
  workspaceId: Scalars['String'];
  surveyId: Scalars['String'];
}>;


export type CreateCsvMutation = { createCsv: Pick<CsvResponse, 'status' | 'file' | 'error'> };

export type CreateProjectMutationVariables = Exact<{
  workspaceId: Scalars['String'];
  payload: CreateProjectInput;
}>;


export type CreateProjectMutation = { createProject: Pick<Project, 'id' | 'desc' | 'title' | 'ids'> };

export type CreateScreenerCsvMutationVariables = Exact<{
  workspaceId: Scalars['String'];
  testId: Scalars['String'];
}>;


export type CreateScreenerCsvMutation = { createScreenerCsv: Pick<CsvResponse, 'status' | 'file' | 'error'> };

export type CreateTestMutationVariables = Exact<{
  workspaceId: Scalars['String'];
  payload: CreateTestInput;
}>;


export type CreateTestMutation = { createTest: Pick<Test, 'id'> };

export type CreateTestConfigMutationVariables = Exact<{
  payload: TestConfigInput;
}>;


export type CreateTestConfigMutation = { createTestConfig: (
    Pick<TestConfigCreateResponse, 'success' | 'message'>
    & { configuration?: Maybe<(
      Pick<TestConfig, 'id' | 'workspaceId' | 'testId' | 'findings' | 'sharedLinkHash' | 'createdAt' | 'createdBy'>
      & { questionConfigs: Array<Pick<QuestionConfig, 'title' | 'visible' | 'context' | 'questionId'>>, optionConfigs: Array<Pick<OptionConfig, 'title' | 'questionOptionId'>> }
    )> }
  ) };

export type FeatureFlagsQueryVariables = Exact<{
  workspaceId?: Maybe<Scalars['String']>;
  accountId?: Maybe<Scalars['String']>;
  orgId?: Maybe<Scalars['String']>;
}>;


export type FeatureFlagsQuery = { featureFlags: Array<Pick<FeatureFlag, 'title' | 'key' | 'description' | 'enabled' | 'config'>> };

export type ManageResponsesMutationVariables = Exact<{
  workspaceId: Scalars['String'];
  surveyId: Scalars['String'];
  payload: ManageResponsesInput;
}>;


export type ManageResponsesMutation = { manageResponses: (
    Pick<ManageResponsesResult, 'success'>
    & { insights?: Maybe<(
      Pick<InsightResponseObject, 'ahash' | 'testId' | 'workspaceId' | 'surveyId' | 'networkTime' | 'processingTime' | 'pValue' | 'minSampleCategory' | 'CIpercentage' | 'isCached'>
      & { insights: Array<Pick<InsightItem, 'questionId' | 'type' | 'demographic' | 'group' | 'option' | 'alpha' | 'magnitude' | 'relMagnitudes'>> }
    )> }
  ) };

export type MgtTestQueryVariables = Exact<{
  workspaceId: Scalars['String'];
  testId: Scalars['String'];
}>;


export type MgtTestQuery = { mgtTest?: Maybe<(
    Pick<MgtTest, 'data'>
    & { allUsers: Array<Pick<User, 'id' | 'fullName' | 'userName' | 'abbreviation' | 'email' | 'admin'>>, followers: Array<Pick<User, 'id' | 'fullName' | 'userName' | 'abbreviation' | 'email' | 'admin'>> }
  )> };

export type OrganizationPriorityQueryVariables = Exact<{
  orgId: Scalars['String'];
  workspaceId?: Maybe<Scalars['String']>;
}>;


export type OrganizationPriorityQuery = { organizationPriority: { activeTests: Array<(
      Pick<ActiveTest, 'id' | 'createdAt' | 'updatedAt' | 'workspaceId'>
      & { payload: Pick<PriorityTestPayload, 'status' | 'title' | 'testType' | 'prioritizedAt' | 'lastSubmittedAt'>, createdBy: Pick<UserReference, 'id' | 'uri' | 'image' | 'name'> }
    )>, priority: (
      Pick<PriorityList, 'uuid'>
      & { list: Array<Pick<PriorityListItem, 'testId' | 'workspaceId' | 'prioritizedAt'>> }
    ), datedOrgTests: Array<Pick<DatedTest, 'workspaceId' | 'id' | 'updatedAt'>> } };

export type OrganizationUsersQueryVariables = Exact<{
  orgId: Scalars['String'];
}>;


export type OrganizationUsersQuery = { organizationUsers: Array<(
    Pick<User, 'id' | 'email'>
    & { payload: Pick<UserPayload, 'lastname' | 'firstname'> }
  )> };

export type ResetPasswordMutationVariables = Exact<{
  userId: Scalars['String'];
  token: Scalars['String'];
  password: Scalars['String'];
}>;


export type ResetPasswordMutation = { resetPassword?: Maybe<Pick<GenericResponse, 'status' | 'error'>> };

export type ForgotPasswordEmailMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ForgotPasswordEmailMutation = { forgotPasswordEmail: Pick<GenericResponse, 'status' | 'error'> };

export type SearchResponsesQueryVariables = Exact<{
  workspaceId: Scalars['String'];
  questionId: Scalars['String'];
  searchTerm: Scalars['String'];
  sharedLinkHash?: Maybe<Scalars['String']>;
}>;


export type SearchResponsesQuery = { searchResponses?: Maybe<{ total: Pick<SearchTotals, 'value'>, hits: Array<(
      Pick<SearchHit, '_id' | '_score'>
      & { highlight?: Maybe<Pick<Highlight, 'text'>> }
    )> }> };

export type SessionQueryVariables = Exact<{ [key: string]: never; }>;


export type SessionQuery = { me?: Maybe<(
    Pick<Session, 'uid' | 'firstName' | 'lastName' | 'email' | 'defaultWorkspaceId' | 'featureConfig' | 'orgAdminAccess' | 'admin'>
    & { workspaces: Array<Pick<Workspace, 'id' | 'createdAt' | 'name' | 'iconUrl' | 'projectCount' | 'testCount' | 'accountManager' | 'organizationId'>>, workspaceAccessLevels: Array<Pick<WorkspaceAccessLevel, 'id' | 'accessLevel'>> }
  )> };

export type SharedPrototypesQueryVariables = Exact<{
  workspaceId: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type SharedPrototypesQuery = { sharedPrototypes: Array<Pick<Prototype, 'id' | 'title' | 'assetType' | 'url'>> };

export type SharedReportsQueryVariables = Exact<{
  workspaceId: Scalars['String'];
  reportIds?: Maybe<Array<Maybe<Scalars['String']>>>;
}>;


export type SharedReportsQuery = { sharedReports: Array<Pick<SharedReports, 'id' | 'reference' | 'client_id' | 'filename' | 'source_id' | 'source_type' | 'creator_name' | 'creator_email' | 'created_at'>> };

export type SurveyQueryVariables = Exact<{
  workspaceId: Scalars['String'];
  testId: Scalars['String'];
  sharedLinkHash?: Maybe<Scalars['String']>;
}>;


export type SurveyQuery = { survey?: Maybe<(
    Pick<Survey, 'id' | 'createdAt' | 'testId'>
    & { respondents?: Maybe<Array<(
      Pick<Respondent, 'id' | 'status' | 'sessionId' | 'simpleId' | 'state' | 'age' | 'standardEmployment' | 'standardHHIUS' | 'standardIndustryPersonal' | 'gender' | 'standardEducation' | 'msIsMobile' | 'region' | 'race' | 'hispanicOrigin' | 'raceAndHispanicOrigin'>
      & { responses?: Maybe<Array<Pick<Response, 'id' | 'status' | 'dataQualityCategories' | 'sentimentLabel' | 'spacyPos' | 'spacyLemma' | 'questionId' | 'respondentSurveyId' | 'otherAnswer' | 'explainAnswer' | 'textAnswer' | 'textArrayAnswer' | 'textMapAnswer'>>> }
    )>>, questions?: Maybe<Array<(
      Pick<Question, 'id' | 'type' | 'text' | 'order' | 'qualifyingTags' | 'hasExplainOpt' | 'hasNaOpt' | 'hasOtherOpt' | 'parentQuestionIds'>
      & { scaleProperties?: Maybe<Pick<ScaleProperties, 'minLabel' | 'maxLabel' | 'minRating' | 'maxRating'>>, options?: Maybe<Array<(
        Pick<QuestionOption, 'id' | 'text' | 'order' | 'hash' | 'qualificationTags' | 'shuffle' | 'isTerminating' | 'isCorrectOption' | 'image' | 'link' | 'label'>
        & { configuration?: Maybe<Pick<OptionConfig, 'title'>> }
      )>>, assets?: Maybe<Array<Pick<QuestionAsset, 'id' | 'type' | 'url' | 'title' | 'forceOpen' | 'questionId'>>>, configuration?: Maybe<Pick<QuestionConfig, 'visible' | 'title'>> }
    )>>, insights?: Maybe<(
      Pick<InsightResponseObject, 'ahash' | 'testId' | 'workspaceId' | 'surveyId' | 'networkTime' | 'processingTime' | 'pValue' | 'minSampleCategory' | 'CIpercentage' | 'isCached'>
      & { insights: Array<Pick<InsightItem, 'questionId' | 'type' | 'demographic' | 'group' | 'option' | 'alpha' | 'magnitude' | 'relMagnitudes'>> }
    )> }
  )> };

export type TemplateQueryVariables = Exact<{
  id: Scalars['String'];
  accountId: Scalars['String'];
}>;


export type TemplateQuery = { template: Pick<Template, 'id' | 'created_by' | 'title' | 'description' | 'featured' | 'template_fields' | 'questions' | 'parent_id' | 'created_at' | 'hidden'> };

export type TemplatesByAccountQueryVariables = Exact<{
  accountId: Scalars['String'];
}>;


export type TemplatesByAccountQuery = { templatesByAccount: Array<Pick<Template, 'id' | 'created_by' | 'title' | 'description' | 'featured' | 'template_fields' | 'questions' | 'parent_id' | 'created_at' | 'hidden'>> };

export type TestConfigPublicQueryVariables = Exact<{
  workspaceId?: Maybe<Scalars['String']>;
  testId?: Maybe<Scalars['String']>;
  sharedLinkHash?: Maybe<Scalars['String']>;
}>;


export type TestConfigPublicQuery = { testConfig?: Maybe<(
    Pick<TestConfig, 'id' | 'workspaceId' | 'testId' | 'findings' | 'sharedLinkHash' | 'createdAt' | 'createdBy'>
    & { testMetaDetails?: Maybe<(
      Pick<TestMetaDetails, 'title' | 'type' | 'completedAt' | 'workspaceIcon'>
      & { audience?: Maybe<Pick<Audience, '_id' | 'payload'>>, branding?: Maybe<Pick<Branding, 'qualitativePalette' | 'divergentPalette' | 'monochromatic' | 'sequentialPalette'>> }
    )>, questionConfigs: Array<Pick<QuestionConfig, 'id' | 'title' | 'visible' | 'context' | 'surveyId' | 'questionId'>>, optionConfigs: Array<Pick<OptionConfig, 'id' | 'title' | 'questionOptionId'>> }
  )> };

export type TestConfigQueryVariables = Exact<{
  workspaceId?: Maybe<Scalars['String']>;
  testId?: Maybe<Scalars['String']>;
  sharedLinkHash?: Maybe<Scalars['String']>;
}>;


export type TestConfigQuery = { testConfig?: Maybe<(
    Pick<TestConfig, 'id' | 'workspaceId' | 'testId' | 'findings' | 'sharedLinkHash' | 'createdAt' | 'createdBy'>
    & { questionConfigs: Array<Pick<QuestionConfig, 'id' | 'title' | 'visible' | 'context' | 'surveyId' | 'questionId'>>, optionConfigs: Array<Pick<OptionConfig, 'id' | 'title' | 'questionOptionId'>> }
  )> };

export type ToggleSharedLinkMutationVariables = Exact<{
  workspaceId: Scalars['String'];
  testId: Scalars['String'];
  createLink: Scalars['Boolean'];
}>;


export type ToggleSharedLinkMutation = { toggleSharedLink: Pick<ToggleShareLinkResponse, 'success' | 'shareLinkHash'> };

export type UpdateAudienceMutationVariables = Exact<{
  accountId: Scalars['String'];
  audienceId: Scalars['String'];
  payload: AudienceInput;
}>;


export type UpdateAudienceMutation = { updateAudience?: Maybe<Pick<Audience, '_id' | 'name' | 'payload'>> };

export type UpdateBrandingMutationVariables = Exact<{
  workspaceId: Scalars['String'];
  payload: BrandingInput;
}>;


export type UpdateBrandingMutation = { updateBranding?: Maybe<Pick<Branding, 'id' | 'workspaceId' | 'qualitativePalette' | 'divergentPalette' | 'monochromatic' | 'sequentialPalette' | 'createdAt'>> };

export type UpdateProjectMutationVariables = Exact<{
  workspaceId: Scalars['String'];
  projectId: Scalars['String'];
  payload: UpdateProjectInput;
}>;


export type UpdateProjectMutation = { updateProject: Pick<Project, 'id'> };

export type UpdateTestMutationVariables = Exact<{
  workspaceId: Scalars['String'];
  testId: Scalars['String'];
  payload: UpdateTestInput;
}>;


export type UpdateTestMutation = { updateTest: Pick<Test, 'id'> };

export type UserPermissionQueryVariables = Exact<{
  groupId: Scalars['String'];
}>;


export type UserPermissionQuery = { userPermission: (
    Pick<GroupsPermission, 'id' | 'type'>
    & { permissions: Pick<PermissionsObject, 'templateQuestionModification'> }
  ) };

export type WorkspacePreferencesQueryVariables = Exact<{
  workspaceId: Scalars['String'];
}>;


export type WorkspacePreferencesQuery = { userPayload?: Maybe<Pick<UserPayload, 'preferences'>>, workspaceUsers: Array<(
    Pick<User, 'id' | 'email' | 'type'>
    & { payload: Pick<UserPayload, 'firstname' | 'lastname' | 'permissions'> }
  )> };

export type WorkspaceWithProjectsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type WorkspaceWithProjectsQuery = { workspace?: Maybe<(
    Pick<WorkspaceWithTests, 'id' | 'name' | 'createdAt' | 'organizationId' | 'accountId'>
    & { projects: Array<Pick<Project, 'id' | 'title' | 'ids'>>, accountAudiences: Array<Pick<Audience, 'payload' | 'name' | '_id'>> }
  )> };

export type WorkspaceWithTestsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type WorkspaceWithTestsQuery = { workspace?: Maybe<(
    Pick<WorkspaceWithTests, 'id' | 'name' | 'createdAt' | 'accountId' | 'organizationId' | 'iconUrl'>
    & { mgtWorkspace: Pick<MgtWorkspace, 'id' | 'name' | 'createdAt' | 'updatedAt' | 'drops' | 'payload'>, tests: Array<Pick<Test, 'id' | 'createdAt' | 'title' | 'status' | 'tags'>>, accountAudiences: Array<Pick<Audience, '_id' | 'payload' | 'name'>>, branding?: Maybe<Pick<Branding, 'id' | 'qualitativePalette' | 'divergentPalette' | 'monochromatic' | 'sequentialPalette'>> }
  )> };

export type WorkspacesByOrgIdQueryVariables = Exact<{
  orgId: Scalars['String'];
}>;


export type WorkspacesByOrgIdQuery = { workspacesByOrgId: Array<Pick<OrgWorkspace, 'name' | '_id'>> };


export const AccountDocument = gql`
    query account($accountId: String!) {
  account(id: $accountId) {
    organizations {
      id
      name
    }
  }
}
    `;
export const AudienceDocument = gql`
    query audience($id: String!, $accountId: String!) {
  audience(id: $id, accountId: $accountId) {
    name
    _id
    payload
    drops
  }
}
    `;
export const AudienceTestCountsDocument = gql`
    query audienceTestCounts($accountId: String!, $audienceIds: [String!]!) {
  audienceTestCounts(accountId: $accountId, audienceIds: $audienceIds) {
    id
    count
  }
}
    `;
export const ChangePasswordDocument = gql`
    mutation changePassword($userId: String!, $payload: NewPasswordPayload!) {
  changePassword(userId: $userId, payload: $payload) {
    status
    error
  }
}
    `;
export const CheckResetPasswordTokenDocument = gql`
    query checkResetPasswordToken($token: String!) {
  checkResetPasswordToken(token: $token) {
    status
    userId
    error
  }
}
    `;
export const CreateCommentDocument = gql`
    mutation createComment($workspaceId: String!, $testId: String!, $payload: UserCommentInput!) {
  createComment(workspaceId: $workspaceId, testId: $testId, payload: $payload) {
    firstName
    comment
    id
  }
}
    `;
export const CreateCsvDocument = gql`
    mutation createCsv($workspaceId: String!, $surveyId: String!) {
  createCsv(workspaceId: $workspaceId, surveyId: $surveyId) {
    status
    file
    error
  }
}
    `;
export const CreateProjectDocument = gql`
    mutation createProject($workspaceId: String!, $payload: CreateProjectInput!) {
  createProject(workspaceId: $workspaceId, payload: $payload) {
    id
    desc
    title
    ids
  }
}
    `;
export const CreateScreenerCsvDocument = gql`
    mutation createScreenerCsv($workspaceId: String!, $testId: String!) {
  createScreenerCsv(workspaceId: $workspaceId, testId: $testId) {
    status
    file
    error
  }
}
    `;
export const CreateTestDocument = gql`
    mutation createTest($workspaceId: String!, $payload: CreateTestInput!) {
  createTest(workspaceId: $workspaceId, payload: $payload) {
    id
  }
}
    `;
export const CreateTestConfigDocument = gql`
    mutation createTestConfig($payload: TestConfigInput!) {
  createTestConfig(payload: $payload) {
    success
    message
    configuration {
      id
      workspaceId
      testId
      findings
      sharedLinkHash
      createdAt
      createdBy
      questionConfigs {
        title
        visible
        context
        questionId
      }
      optionConfigs {
        title
        questionOptionId
      }
    }
  }
}
    `;
export const FeatureFlagsDocument = gql`
    query featureFlags($workspaceId: String, $accountId: String, $orgId: String) {
  featureFlags(workspaceId: $workspaceId, accountId: $accountId, orgId: $orgId) {
    title
    key
    description
    enabled
    config
  }
}
    `;
export const ManageResponsesDocument = gql`
    mutation manageResponses($workspaceId: String!, $surveyId: String!, $payload: ManageResponsesInput!) {
  manageResponses(workspaceId: $workspaceId, surveyId: $surveyId, payload: $payload) {
    success
    insights {
      ahash
      testId
      workspaceId
      surveyId
      insights {
        questionId
        type
        demographic
        group
        option
        alpha
        magnitude
        relMagnitudes
      }
      networkTime
      processingTime
      pValue
      minSampleCategory
      CIpercentage
      isCached
    }
  }
}
    `;
export const MgtTestDocument = gql`
    query mgtTest($workspaceId: String!, $testId: String!) {
  mgtTest(workspaceId: $workspaceId, testId: $testId) {
    data
    allUsers {
      id
      fullName
      userName
      abbreviation
      email
      admin
    }
    followers {
      id
      fullName
      userName
      abbreviation
      email
      admin
    }
  }
}
    `;
export const OrganizationPriorityDocument = gql`
    query organizationPriority($orgId: String!, $workspaceId: String) {
  organizationPriority(orgId: $orgId, workspaceId: $workspaceId) {
    activeTests {
      id
      payload {
        status
        title
        testType
        prioritizedAt
        lastSubmittedAt
      }
      createdAt
      updatedAt
      createdBy {
        id
        uri
        image
        name
      }
      workspaceId
    }
    priority {
      list {
        testId
        workspaceId
        prioritizedAt
      }
      uuid
    }
    datedOrgTests {
      workspaceId
      id
      updatedAt
    }
  }
}
    `;
export const OrganizationUsersDocument = gql`
    query organizationUsers($orgId: String!) {
  organizationUsers(orgId: $orgId) {
    payload {
      lastname
      firstname
    }
    id
    email
  }
}
    `;
export const ResetPasswordDocument = gql`
    mutation resetPassword($userId: String!, $token: String!, $password: String!) {
  resetPassword(userId: $userId, token: $token, password: $password) {
    status
    error
  }
}
    `;
export const ForgotPasswordEmailDocument = gql`
    mutation forgotPasswordEmail($email: String!) {
  forgotPasswordEmail(email: $email) {
    status
    error
  }
}
    `;
export const SearchResponsesDocument = gql`
    query searchResponses($workspaceId: String!, $questionId: String!, $searchTerm: String!, $sharedLinkHash: String) {
  searchResponses(searchTerm: $searchTerm, workspaceId: $workspaceId, questionId: $questionId, sharedLinkHash: $sharedLinkHash) {
    total {
      value
    }
    hits {
      _id
      _score
      highlight {
        text
      }
    }
  }
}
    `;
export const SessionDocument = gql`
    query session {
  me {
    uid
    firstName
    lastName
    email
    defaultWorkspaceId
    featureConfig
    workspaces {
      id
      createdAt
      name
      iconUrl
      projectCount
      testCount
      accountManager
      organizationId
    }
    workspaceAccessLevels {
      id
      accessLevel
    }
    orgAdminAccess
    admin
  }
}
    `;
export const SharedPrototypesDocument = gql`
    query sharedPrototypes($workspaceId: String!, $projectId: String!) {
  sharedPrototypes(workspaceId: $workspaceId, projectId: $projectId) {
    id
    title
    assetType
    url
  }
}
    `;
export const SharedReportsDocument = gql`
    query sharedReports($workspaceId: String!, $reportIds: [String]) {
  sharedReports(workspaceId: $workspaceId, reportIds: $reportIds) {
    id
    reference
    client_id
    filename
    source_id
    source_type
    creator_name
    creator_email
    created_at
  }
}
    `;
export const SurveyDocument = gql`
    query survey($workspaceId: String!, $testId: String!, $sharedLinkHash: String) {
  survey(workspaceId: $workspaceId, testId: $testId, sharedLinkHash: $sharedLinkHash) {
    id
    createdAt
    testId
    respondents {
      id
      status
      sessionId
      simpleId
      state
      age
      standardEmployment
      standardHHIUS
      standardIndustryPersonal
      gender
      standardEducation
      msIsMobile
      region
      race
      hispanicOrigin
      raceAndHispanicOrigin
      responses {
        id
        status
        dataQualityCategories
        sentimentLabel
        spacyPos
        spacyLemma
        questionId
        respondentSurveyId
        otherAnswer
        explainAnswer
        textAnswer
        textArrayAnswer
        textMapAnswer
      }
    }
    questions {
      id
      type
      text
      order
      qualifyingTags
      hasExplainOpt
      hasNaOpt
      hasOtherOpt
      parentQuestionIds
      scaleProperties {
        minLabel
        maxLabel
        minRating
        maxRating
      }
      options {
        id
        text
        order
        hash
        qualificationTags
        shuffle
        isTerminating
        isCorrectOption
        image
        link
        label
        configuration {
          title
        }
      }
      assets {
        id
        type
        url
        title
        forceOpen
        questionId
      }
      configuration {
        visible
        title
      }
      type
    }
    insights {
      ahash
      testId
      workspaceId
      surveyId
      insights {
        questionId
        type
        demographic
        group
        option
        alpha
        magnitude
        relMagnitudes
      }
      networkTime
      processingTime
      pValue
      minSampleCategory
      CIpercentage
      isCached
    }
  }
}
    `;
export const TemplateDocument = gql`
    query template($id: String!, $accountId: String!) {
  template(id: $id, accountId: $accountId) {
    id
    created_by
    title
    description
    featured
    template_fields
    questions
    parent_id
    created_at
    hidden
  }
}
    `;
export const TemplatesByAccountDocument = gql`
    query templatesByAccount($accountId: String!) {
  templatesByAccount(accountId: $accountId) {
    id
    created_by
    title
    description
    featured
    template_fields
    questions
    parent_id
    created_at
    hidden
  }
}
    `;
export const TestConfigPublicDocument = gql`
    query testConfigPublic($workspaceId: String, $testId: String, $sharedLinkHash: String) {
  testConfig(workspaceId: $workspaceId, testId: $testId, sharedLinkHash: $sharedLinkHash) {
    id
    workspaceId
    testId
    findings
    sharedLinkHash
    createdAt
    createdBy
    testMetaDetails {
      title
      type
      completedAt
      workspaceIcon
      audience {
        _id
        payload
      }
      branding {
        qualitativePalette
        divergentPalette
        monochromatic
        sequentialPalette
      }
    }
    questionConfigs {
      id
      title
      visible
      context
      surveyId
      questionId
    }
    optionConfigs {
      id
      title
      questionOptionId
    }
  }
}
    `;
export const TestConfigDocument = gql`
    query testConfig($workspaceId: String, $testId: String, $sharedLinkHash: String) {
  testConfig(workspaceId: $workspaceId, testId: $testId, sharedLinkHash: $sharedLinkHash) {
    id
    workspaceId
    testId
    findings
    sharedLinkHash
    createdAt
    createdBy
    questionConfigs {
      id
      title
      visible
      context
      surveyId
      questionId
    }
    optionConfigs {
      id
      title
      questionOptionId
    }
  }
}
    `;
export const ToggleSharedLinkDocument = gql`
    mutation toggleSharedLink($workspaceId: String!, $testId: String!, $createLink: Boolean!) {
  toggleSharedLink(workspaceId: $workspaceId, testId: $testId, createLink: $createLink) {
    success
    shareLinkHash
  }
}
    `;
export const UpdateAudienceDocument = gql`
    mutation updateAudience($accountId: String!, $audienceId: String!, $payload: AudienceInput!) {
  updateAudience(accountId: $accountId, audienceId: $audienceId, payload: $payload) {
    _id
    name
    payload
  }
}
    `;
export const UpdateBrandingDocument = gql`
    mutation updateBranding($workspaceId: String!, $payload: BrandingInput!) {
  updateBranding(workspaceId: $workspaceId, payload: $payload) {
    id
    workspaceId
    qualitativePalette
    divergentPalette
    monochromatic
    sequentialPalette
    createdAt
  }
}
    `;
export const UpdateProjectDocument = gql`
    mutation updateProject($workspaceId: String!, $projectId: String!, $payload: UpdateProjectInput!) {
  updateProject(workspaceId: $workspaceId, projectId: $projectId, payload: $payload) {
    id
  }
}
    `;
export const UpdateTestDocument = gql`
    mutation updateTest($workspaceId: String!, $testId: String!, $payload: UpdateTestInput!) {
  updateTest(workspaceId: $workspaceId, testId: $testId, payload: $payload) {
    id
  }
}
    `;
export const UserPermissionDocument = gql`
    query userPermission($groupId: String!) {
  userPermission(groupId: $groupId) {
    id
    type
    permissions {
      templateQuestionModification
    }
  }
}
    `;
export const WorkspacePreferencesDocument = gql`
    query workspacePreferences($workspaceId: String!) {
  userPayload {
    preferences
  }
  workspaceUsers(workspaceId: $workspaceId) {
    payload {
      firstname
      lastname
      permissions
    }
    id
    email
    type
  }
}
    `;
export const WorkspaceWithProjectsDocument = gql`
    query workspaceWithProjects($id: String!) {
  workspace(id: $id) {
    id
    name
    createdAt
    organizationId
    accountId
    projects {
      id
      title
      ids
    }
    accountAudiences {
      payload
      name
      _id
    }
  }
}
    `;
export const WorkspaceWithTestsDocument = gql`
    query workspaceWithTests($id: String!) {
  workspace(id: $id) {
    id
    name
    createdAt
    accountId
    organizationId
    mgtWorkspace {
      id
      name
      createdAt
      updatedAt
      drops
      payload
    }
    iconUrl
    tests {
      id
      createdAt
      title
      status
      tags
    }
    accountAudiences {
      _id
      payload
      name
    }
    branding {
      id
      qualitativePalette
      divergentPalette
      monochromatic
      sequentialPalette
    }
  }
}
    `;
export const WorkspacesByOrgIdDocument = gql`
    query workspacesByOrgId($orgId: String!) {
  workspacesByOrgId(orgId: $orgId) {
    name
    _id
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: () => Promise<T>) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = sdkFunction => sdkFunction();
export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    account(variables: AccountQueryVariables): Promise<AccountQuery> {
      return withWrapper(() => client.request<AccountQuery>(print(AccountDocument), variables));
    },
    audience(variables: AudienceQueryVariables): Promise<AudienceQuery> {
      return withWrapper(() => client.request<AudienceQuery>(print(AudienceDocument), variables));
    },
    audienceTestCounts(variables: AudienceTestCountsQueryVariables): Promise<AudienceTestCountsQuery> {
      return withWrapper(() => client.request<AudienceTestCountsQuery>(print(AudienceTestCountsDocument), variables));
    },
    changePassword(variables: ChangePasswordMutationVariables): Promise<ChangePasswordMutation> {
      return withWrapper(() => client.request<ChangePasswordMutation>(print(ChangePasswordDocument), variables));
    },
    checkResetPasswordToken(variables: CheckResetPasswordTokenQueryVariables): Promise<CheckResetPasswordTokenQuery> {
      return withWrapper(() => client.request<CheckResetPasswordTokenQuery>(print(CheckResetPasswordTokenDocument), variables));
    },
    createComment(variables: CreateCommentMutationVariables): Promise<CreateCommentMutation> {
      return withWrapper(() => client.request<CreateCommentMutation>(print(CreateCommentDocument), variables));
    },
    createCsv(variables: CreateCsvMutationVariables): Promise<CreateCsvMutation> {
      return withWrapper(() => client.request<CreateCsvMutation>(print(CreateCsvDocument), variables));
    },
    createProject(variables: CreateProjectMutationVariables): Promise<CreateProjectMutation> {
      return withWrapper(() => client.request<CreateProjectMutation>(print(CreateProjectDocument), variables));
    },
    createScreenerCsv(variables: CreateScreenerCsvMutationVariables): Promise<CreateScreenerCsvMutation> {
      return withWrapper(() => client.request<CreateScreenerCsvMutation>(print(CreateScreenerCsvDocument), variables));
    },
    createTest(variables: CreateTestMutationVariables): Promise<CreateTestMutation> {
      return withWrapper(() => client.request<CreateTestMutation>(print(CreateTestDocument), variables));
    },
    createTestConfig(variables: CreateTestConfigMutationVariables): Promise<CreateTestConfigMutation> {
      return withWrapper(() => client.request<CreateTestConfigMutation>(print(CreateTestConfigDocument), variables));
    },
    featureFlags(variables?: FeatureFlagsQueryVariables): Promise<FeatureFlagsQuery> {
      return withWrapper(() => client.request<FeatureFlagsQuery>(print(FeatureFlagsDocument), variables));
    },
    manageResponses(variables: ManageResponsesMutationVariables): Promise<ManageResponsesMutation> {
      return withWrapper(() => client.request<ManageResponsesMutation>(print(ManageResponsesDocument), variables));
    },
    mgtTest(variables: MgtTestQueryVariables): Promise<MgtTestQuery> {
      return withWrapper(() => client.request<MgtTestQuery>(print(MgtTestDocument), variables));
    },
    organizationPriority(variables: OrganizationPriorityQueryVariables): Promise<OrganizationPriorityQuery> {
      return withWrapper(() => client.request<OrganizationPriorityQuery>(print(OrganizationPriorityDocument), variables));
    },
    organizationUsers(variables: OrganizationUsersQueryVariables): Promise<OrganizationUsersQuery> {
      return withWrapper(() => client.request<OrganizationUsersQuery>(print(OrganizationUsersDocument), variables));
    },
    resetPassword(variables: ResetPasswordMutationVariables): Promise<ResetPasswordMutation> {
      return withWrapper(() => client.request<ResetPasswordMutation>(print(ResetPasswordDocument), variables));
    },
    forgotPasswordEmail(variables: ForgotPasswordEmailMutationVariables): Promise<ForgotPasswordEmailMutation> {
      return withWrapper(() => client.request<ForgotPasswordEmailMutation>(print(ForgotPasswordEmailDocument), variables));
    },
    searchResponses(variables: SearchResponsesQueryVariables): Promise<SearchResponsesQuery> {
      return withWrapper(() => client.request<SearchResponsesQuery>(print(SearchResponsesDocument), variables));
    },
    session(variables?: SessionQueryVariables): Promise<SessionQuery> {
      return withWrapper(() => client.request<SessionQuery>(print(SessionDocument), variables));
    },
    sharedPrototypes(variables: SharedPrototypesQueryVariables): Promise<SharedPrototypesQuery> {
      return withWrapper(() => client.request<SharedPrototypesQuery>(print(SharedPrototypesDocument), variables));
    },
    sharedReports(variables: SharedReportsQueryVariables): Promise<SharedReportsQuery> {
      return withWrapper(() => client.request<SharedReportsQuery>(print(SharedReportsDocument), variables));
    },
    survey(variables: SurveyQueryVariables): Promise<SurveyQuery> {
      return withWrapper(() => client.request<SurveyQuery>(print(SurveyDocument), variables));
    },
    template(variables: TemplateQueryVariables): Promise<TemplateQuery> {
      return withWrapper(() => client.request<TemplateQuery>(print(TemplateDocument), variables));
    },
    templatesByAccount(variables: TemplatesByAccountQueryVariables): Promise<TemplatesByAccountQuery> {
      return withWrapper(() => client.request<TemplatesByAccountQuery>(print(TemplatesByAccountDocument), variables));
    },
    testConfigPublic(variables?: TestConfigPublicQueryVariables): Promise<TestConfigPublicQuery> {
      return withWrapper(() => client.request<TestConfigPublicQuery>(print(TestConfigPublicDocument), variables));
    },
    testConfig(variables?: TestConfigQueryVariables): Promise<TestConfigQuery> {
      return withWrapper(() => client.request<TestConfigQuery>(print(TestConfigDocument), variables));
    },
    toggleSharedLink(variables: ToggleSharedLinkMutationVariables): Promise<ToggleSharedLinkMutation> {
      return withWrapper(() => client.request<ToggleSharedLinkMutation>(print(ToggleSharedLinkDocument), variables));
    },
    updateAudience(variables: UpdateAudienceMutationVariables): Promise<UpdateAudienceMutation> {
      return withWrapper(() => client.request<UpdateAudienceMutation>(print(UpdateAudienceDocument), variables));
    },
    updateBranding(variables: UpdateBrandingMutationVariables): Promise<UpdateBrandingMutation> {
      return withWrapper(() => client.request<UpdateBrandingMutation>(print(UpdateBrandingDocument), variables));
    },
    updateProject(variables: UpdateProjectMutationVariables): Promise<UpdateProjectMutation> {
      return withWrapper(() => client.request<UpdateProjectMutation>(print(UpdateProjectDocument), variables));
    },
    updateTest(variables: UpdateTestMutationVariables): Promise<UpdateTestMutation> {
      return withWrapper(() => client.request<UpdateTestMutation>(print(UpdateTestDocument), variables));
    },
    userPermission(variables: UserPermissionQueryVariables): Promise<UserPermissionQuery> {
      return withWrapper(() => client.request<UserPermissionQuery>(print(UserPermissionDocument), variables));
    },
    workspacePreferences(variables: WorkspacePreferencesQueryVariables): Promise<WorkspacePreferencesQuery> {
      return withWrapper(() => client.request<WorkspacePreferencesQuery>(print(WorkspacePreferencesDocument), variables));
    },
    workspaceWithProjects(variables: WorkspaceWithProjectsQueryVariables): Promise<WorkspaceWithProjectsQuery> {
      return withWrapper(() => client.request<WorkspaceWithProjectsQuery>(print(WorkspaceWithProjectsDocument), variables));
    },
    workspaceWithTests(variables: WorkspaceWithTestsQueryVariables): Promise<WorkspaceWithTestsQuery> {
      return withWrapper(() => client.request<WorkspaceWithTestsQuery>(print(WorkspaceWithTestsDocument), variables));
    },
    workspacesByOrgId(variables: WorkspacesByOrgIdQueryVariables): Promise<WorkspacesByOrgIdQuery> {
      return withWrapper(() => client.request<WorkspacesByOrgIdQuery>(print(WorkspacesByOrgIdDocument), variables));
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;